import { useState, useEffect, useContext, useMemo } from 'react'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'


import { AppContext } from '/providers/app-context'
import { getPass, getPassNotifications } from '/providers/passes-api'

import NotifyPassSubpageLayout from '/components/passes/notify-pass-subpage-layout'
import HelpText from '/help/pass-notifications'
import NotificationsTable from '/components/passes/notifications-table'

const PassMessages = () => {

  const navigate = useNavigate()
  
  const { templateId, passId } = useParams()
  const { apiSource, apiKey, templates, passes, setPasses } = useContext(AppContext)

  const location = useLocation()

  const [pass, setPass] = useState(() => location.state?.pass ?? passes.find(item => item.template_id === templateId && item.pass_id === passId))
  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])


  useEffect(() => {
    if (pass) return
    getPassData()
  }, [pass, templateId, passId])

  const getPassData = async () => {
    const p = await getPass({ apiSource, apiKey, passId })
    if (p.ok === false || !p.pass) return navigate("/templates")
    setPasses(current => {
      const idx = current.findIndex(item => item.template_id === templateId && item.pass_id === passId)
      if (idx < 0) return [...current, p.pass]
      const next = [...current]
      next[idx] = p.pass
      return next
    })
    setPass(p.pass)
  }

  return (
    <NotifyPassSubpageLayout title={`Notification history (${pass?.pass_id})`}  HelpText={HelpText} heading={`${pass?.pass_id} ${pass?.mode === "test" ? " [test]" : ""}`} template={template} pass={pass} onClose={() => navigate(`/templates/${templateId}/notify-passes`)}>
      <Content templateId={templateId} pass={pass} />        
    </NotifyPassSubpageLayout>
  )
}

export default PassMessages

const Content = ({ pass }) => {

  const { templateId, passId } = useParams()
  const { apiSource, apiKey } = useContext(AppContext)

  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(true)

  const getNotifications = async () => {
    const n = await getPassNotifications({ apiSource, apiKey, passId })
    if (n.ok) {
      setNotifications(n.notifications)
    } else {
      enqueueSnackbar({ message: n.error, variant: 'error' })
    }

    setLoading(false)
  }

  useEffect(() => {
    if (pass) getNotifications()
  }, [templateId, passId, pass])

  if (!pass) return null

  return (
    <>
      <div className='flex flex-row h-full w-full gap-5 overflow-auto max-w-full'>
        <NotificationsTable templateId={templateId} pass={pass} data={notifications} loading={loading} refreshNotifications={getNotifications}/>
      </div>
    </>
  )
}
